var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 13l-1.028 1.092 1.028.968 1.028-.968L6.375 13zm11.653-8.908l1.092-1.028L17.064.88l-1.092 1.028 2.056 2.184zM.972 9.975l4.375 4.117 2.056-2.184L3.028 7.79.972 9.975zm6.431 4.117l10.625-10-2.056-2.184-10.625 10 2.056 2.184z",
    fill: "#fff"
  })));
}
export default SvgBigCheck;